/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = require('../config');
var browser = require('../../helper/browser');

var Redpack = function () {
    function Redpack() {
        (0, _classCallCheck3["default"])(this, Redpack);

        _scope.Feature.Room(this);
        _scope.Feature.EventBus(this);
    }

    (0, _createClass3["default"])(Redpack, [{
        key: '_canSnatch',
        value: function _canSnatch(type) {
            if (type == 1) {
                if (!browser.isMobileWechat()) {
                    return {
                        status: 'n',
                        flag: 101,
                        info: '当前红包为微信红包，只有在手机微信中才能抢红包'
                    };
                }
                if (!_scope.Utils.GetCookie('openId')) {
                    return {
                        status: 'n',
                        flag: 102,
                        info: '当前红包为微信红包，需要先进行微信登录才能抢红包'
                    };
                }
                return {
                    status: 'y',
                    flag: 100,
                    info: '当前红包可抢'
                };
            }
            if (type == 2) {
                if (!browser.isDingding()) {
                    return {
                        status: 'n',
                        flag: 103,
                        info: '当前红包为钉钉红包，只有在钉钉中才能抢红包'
                    };
                }

                if (!_scope.Utils.GetCookie('openId')) {
                    return {
                        status: 'n',
                        flag: 104,
                        info: '当前红包为钉钉红包，需要先进行钉钉登录才能抢红包'
                    };
                }

                return {
                    status: 'y',
                    flag: 100,
                    info: '当前红包可抢'
                };
            }

            return {
                status: 'n',
                flag: 105,
                info: '红包类型未知'
            };
        }
    }, {
        key: 'GetRedpackStatus',
        value: function GetRedpackStatus(hashid, cb) {
            var openId = _scope.Utils.GetCookie('openId');
            var param = { openId: openId, redpackHashid: hashid };
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { amount: data.amount, snatched: data.snatched } };
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.PostForm(config.REDPACK_STATUS_URL, param, callback);
        }
    }, {
        key: 'GetRedpackRecord',
        value: function GetRedpackRecord(hashid, cb) {
            var param = { redpackHashid: hashid };
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { redpack: data.redpack, snatch_list: data.data } };
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.PostForm(config.REDPACK_RECORD_URL, param, callback);
        }
    }, {
        key: 'SnatchRedpack',
        value: function SnatchRedpack(hashid, cb) {
            var param = {
                redpackHashid: hashid,
                snatcherOpenId: _scope.Utils.GetCookie('openId'),
                snatcherAvatar: _scope.Utils.GetCookie('avatar'),
                snatcherName: _scope.Utils.GetCookie('user')
            };
            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { amount: data.amount, redpack_id: data.redpack_id } };
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.PostForm(config.REDPACK_SNATCH_URL, param, callback);
        }
    }, {
        key: 'ParseRedpackComment',
        value: function ParseRedpackComment(comment) {
            var div = document.createElement('div');
            div.innerHTML = comment.message;
            var envoDom = div.getElementsByTagName('div')[0];
            if (!envoDom) {
                return { status: 'n', flag: 101, info: '当前评论不是红包评论' };
            }
            var id = envoDom.getAttribute('data-id');
            var type = +envoDom.getAttribute('data-type');
            var wishes = envoDom.getAttribute('data-wishes');
            var name = envoDom.getAttribute('data-name');
            if (!id) {
                return { status: 'n', flag: 102, info: '找不到红包hashid' };
            }
            var canSnatch = this._canSnatch(type);
            return {
                status: 'y',
                flag: 100,
                info: '解析红包信息成功',
                data: {
                    redpack: {
                        type: type, wishes: wishes, name: name,
                        hashid: id
                    },
                    can_snatch: canSnatch
                }
            };
        }
    }]);
    return Redpack;
}();

module.exports = Redpack;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Redpack.js
 ** module id = 183
 ** module chunks = 1
 **/